import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';

import Button from '~/components/button';
import {
  analyticsBeacon,
  DeprecatedEventType,
  EventType,
} from '~/utils/analytics';

import styles from '~/components/static/video-player/video-player.module.scss';

const VideoPlayer = ({
  className,
  eventName,
  posterImg,
  videoSrc,
  videoType,
}) => {
  const [videoPlaying, setVideoPlaying] = useState(true);
  const videoRef = useRef(null);
  const controlsRef = useRef(null);

  // Enable default controls but hide them if browser supports custom
  useEffect(() => {
    const supportsVideo = !!document.createElement('video').canPlayType;

    if (supportsVideo) {
      videoRef.current.controls = false;
      controlsRef.current.style.display = 'inline-block';
    }
  }, [controlsRef, videoRef]);

  const videoHandler = (e) => {
    e.preventDefault();
    if (!videoPlaying) {
      videoRef.current.play();
      setVideoPlaying(true);
    } else if (videoPlaying) {
      videoRef.current.pause();
      setVideoPlaying(false);
    }
  };

  return (
    <div className={cx(styles.videoContainer, className)}>
      <figure className={styles.videoWrapper}>
        <video
          autoPlay
          className={styles.videoPlayer}
          controls
          controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
          loop
          muted
          playsInline
          poster={posterImg}
          ref={videoRef}
          onPlay={() => {
            analyticsBeacon.emit(DeprecatedEventType.PLAY_VIDEO, eventName);
            analyticsBeacon.emit(EventType.VIDEO_PLAYED, eventName);
          }}
        >
          <source src={videoSrc} type={videoType} />
        </video>
      </figure>
      <Button
        type="button"
        className={styles.videoControls}
        onClick={(e) => videoHandler(e, videoPlaying)}
        ref={controlsRef}
        style={{ display: 'none' }}
      >
        <img
          alt="Play-Pause button"
          className={styles.controlsIcon}
          height="28"
          width="28"
          src={
            videoPlaying ? '/icons/pause-button.svg' : '/icons/play-button.svg'
          }
        />
      </Button>
    </div>
  );
};

export default VideoPlayer;
